import axios from '@/requests';
import { Browser, BrowserTypesOfSearch } from '@/store/modules/browser/types';
import { TypeNode } from '../store/modules/browser/types';
import { Task } from "@/store/modules/task/types";
export interface GetBrowserTypesReq {
    projId: string,
    uid: string,
    pageNum: number,
    pageSize: number,
}

export interface GetBrowserDetailsByPageReq {
    projId: string,
    uid: string,
    browserType: string,
    browserUser: string,
    infoType: string,
    taskId: string,
    pageSize: number,
    pageNum: number,
}

export interface GetBrowserDetailsReq {
    projId: string,
    uid: string,
    browserType: string,
    browserUser: string,
    infoType: string,
    taskId: string,
}
export interface GetSearchDetailsReq {
    projId: string,
    uid: string,
    target: string,
    browserType: string,
    browserUser: string,
    infoType: string,
    taskId: string
    searchType: boolean,
}


export const BrowserAPI = {
    async getBrowserListByUid(getBrowserTypesReq: GetBrowserTypesReq) {
        try {
            const res = await axios.get<Browser[]>('/Browser/getBrowserTypeListByUid', getBrowserTypesReq);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getInfoByType(getBrowserDetailsReq: GetBrowserDetailsReq) {
        try {
            const res = await axios.get<Browser[]>('/Browser/getInfoByType', getBrowserDetailsReq);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async GetDefaultBrowserHistory(projId: string, uid: string, taskId: string) {
        try {
            const res = await axios.get<string[]>('/Browser/getDefaultBrowserHistory', { "projId": projId, "uid": uid, "taskId": taskId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getAllBrowserTypeByUid(projId: string, uid: string, taskId: string) {
        try {
            const res = await axios.get<TypeNode[]>('/Browser/getTypeListByUid', { "projId": projId, "uid": uid, "taskId": taskId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getTypesOfSearch(projId: string, uid: string, target: string, taskId: string, isFuzzy: boolean) {
        try {
            const res = await axios.get<BrowserTypesOfSearch[]>('/Browser/fuzzySearch', { "projId": projId, "uid": uid, "target": target, "taskId": taskId, "searchType": isFuzzy });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }

    },
    async getSearchDetails(getSearchDetails: GetSearchDetailsReq) {
        try {
            const res = await axios.get<Browser[]>('/Browser/getSearchDetailList', getSearchDetails);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getBrowserTaskListByProjIdAndUid(projId: string, uid: string) {
        try {
            const res = await axios.get<Task[]>('/Browser/getBrowserTaskListByProjIdAndUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getPaginationByBrowserType(getBrowserDetailsReq: GetBrowserDetailsReq) {
        try {
            const res = await axios.get<number>('/Browser/getPaginationByBrowserType', getBrowserDetailsReq);
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    // 
}